// interfaces
export interface amountItem {
    fillValue: number,
    giftRatio: number,
    codingRequirement: number,
}
export interface Response {
    code: number;
    msg: string;
    data?: any;
}

export interface PayChannel {
    id: number;
    name: string;
    channelType: string;
    rechargeNotice: string;
    chainType: string| number
}
export interface DepositData {
  channelList: PayChannel[];         
  turnOverValue: number;
  activeChannel: Record<string, any>;
  showCPFIdError: boolean;
  selectedAmount: number | string;
  selecTopup: boolean;
  giftAmount: number;
  isFillField: boolean;
  isSuccess: boolean;
  toastContent: string;
  cpfID:string
  min_amount:number|string,
  max_amount: number|string,
  amountList:amountItem[],
  ercCode : string,
  minErcAmount: string,
  maxErcAmount: string
}

import { callFirstRechargePopupNotShow } from '@/api/deposit';
// function
import { Ref } from 'vue'

export const callDoNotshowFunc = async (
  loadingRef: Ref<any>,
  showSuccess: (msg: string) => void,
  showError: (message: string) => void,
  userStore: any,
  show: Ref<boolean>,
  type: number
) => {
  try {
    const res = await callFirstRechargePopupNotShow(type)
    loadingRef.value.close()
    showSuccess(res.msg)
    userStore.setFirstRechargePopupShowStatus(0)
    userStore.setisFirstRechargeRewardEligible(false)
    show.value = false
    userStore.setRechargeBonusType(0)
  } catch (err:any) {
    show.value = false
    loadingRef.value.close()
    showError(err)
  }
}
